(() => {
  const initPrizeInfo = (root) => {
    const cards = [...root.querySelectorAll(".s26-prize-card--grand")];
    if (!cards.length) return;

    const closeAll = (exceptCard) => {
      cards.forEach((card) => {
        if (exceptCard && card === exceptCard) return;
        card.classList.remove("is-info-open");
        card.querySelector("[data-s26-prize-info]")?.setAttribute("aria-expanded", "false");
      });
    };

    cards.forEach((card) => {
      if (card.dataset.infoBound === "true") return;
      card.dataset.infoBound = "true";

      const button = card.querySelector("[data-s26-prize-info]");
      if (!button) return;

      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const willOpen = !card.classList.contains("is-info-open");
        closeAll(card);
        card.classList.toggle("is-info-open", willOpen);
        button.setAttribute("aria-expanded", willOpen ? "true" : "false");
      });
    });

    if (!document.body.dataset.s26PrizeInfoBound) {
      document.body.dataset.s26PrizeInfoBound = "true";
      document.addEventListener("click", (event) => {
        if (!event.target.closest(".s26-prize-card--grand")) {
          document
            .querySelectorAll(".s26-prize-card--grand.is-info-open")
            .forEach((card) => {
              card.classList.remove("is-info-open");
              card
                .querySelector("[data-s26-prize-info]")
                ?.setAttribute("aria-expanded", "false");
            });
        }
      });

      document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") return;
        document
          .querySelectorAll(".s26-prize-card--grand.is-info-open")
          .forEach((card) => {
            card.classList.remove("is-info-open");
            card
              .querySelector("[data-s26-prize-info]")
              ?.setAttribute("aria-expanded", "false");
          });
      });
    }
  };

  const init = (scope = document) => {
    scope.querySelectorAll?.("[data-s26-prizes]").forEach(initPrizeInfo);
    if (scope.matches?.("[data-s26-prizes]")) initPrizeInfo(scope);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
